import React from 'react';
import Globalizer from '../../../globalizer';
import translateService from '../../../common/translateService';
import common from '../../../common/common';
import './ProductNotes.scss';

const ProductNotes = (props) => {
  Globalizer.init();

  return (
    <div className='prd-notes'>
      {props.freeShipping && (
        <div className='prd-notes-free-shipping'>
          <img
            className='prd-notes-icon-small'
            src={common.contentFromCdn({
              path: '/content/img/fast-delivery.svg',
              keepUrlAsIs: false,
            })}
          />{' '}
          <p>{translateService.get(`productDetail.freeShipping`)}</p>
        </div>
      )}
      <div className='prd-notes-info'>
        {props.countryHasFreeShipping && props.freeShippingThreshold && (
          <div className='prd-note'>
            <a href={props.shippingInfoUrl} target='_blank'>
              <img
                className='prd-notes-icon'
                src={common.contentFromCdn({
                  path: '/content/img/free-shipping.svg',
                  keepUrlAsIs: false,
                })}
              />
            </a>
            <div className='prd-notes-text'>
              <a
                target='_blank'
                href={props.shippingInfoUrl}
                className='prd-link prd-notes-text-heading'
              >
                {translateService.get(`productDetail.freeShippings`)}
              </a>
              <span>
                {translateService.interpolate(
                  `productDetail.freeShippingsNote`,
                  {
                    price: `${props.currencySymbol} ${Globalizer.formatNumber(
                      props.freeShippingThreshold,
                      props.currencyDecimalPlaces,
                    )}`,
                  },
                )}
              </span>
            </div>
          </div>
        )}
        <div className='prd-note'>
          <a href={props.securePaymentsUrl} target='_blank'>
            <img
              className='prd-notes-icon'
              src={common.contentFromCdn({
                path: '/content/img/secure-payments.svg',
                keepUrlAsIs: false,
              })}
            />
          </a>
          <div className='prd-notes-text'>
            <a
              target='_blank'
              href={props.securePaymentsUrl}
              className='prd-link prd-notes-text-heading'
            >
              {translateService.get(`productDetail.securePayments`)}
            </a>
            <span>
              {translateService.get(`productDetail.securePaymentsNote`)}
            </span>
          </div>
        </div>
        <div className='prd-note'>
          <a href={props.shippingInfoUrl} target='_blank'>
            <img
              className='prd-notes-icon'
              src={common.contentFromCdn({
                path: '/content/img/fast-delivery.svg',
                keepUrlAsIs: false,
              })}
            />
          </a>
          <div className='prd-notes-text'>
            <a
              target='_blank'
              href={props.shippingInfoUrl}
              className='prd-link prd-notes-text-heading'
            >
              {translateService.get(`productDetail.fastDispatch`)}
            </a>
            <span>
              {translateService.get(`productDetail.fastDispatchNote`)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductNotes;
